module.exports = __webpack_public_path__ + "media/images/country_flags/sx-03b2be54bcbfb2fb5cc2ced8a8c9740b.png";